var map = {
	"./Bones_room.jpg": 7494,
	"./Exit_Room_void.png": 8944,
	"./Exit_Room_void0.png": 5762,
	"./Exit_room_no_ladder.png": 4124,
	"./Gamestates_background.png": 8696,
	"./GiftShop.png": 717,
	"./Ladder_exit_scene.png": 4445,
	"./Nixie_death_scene.png": 7322,
	"./Nixie_kills_player.png": 3172,
	"./Pit1_death.png": 2024,
	"./Pit2_death.png": 1716,
	"./Water_nixie_death.png": 347,
	"./Water_nixie_evil.png": 3959,
	"./acid_death.png": 4727,
	"./amulet.png": 4013,
	"./cave_intro.png": 555,
	"./censored.png": 4150,
	"./cooked.png": 6012,
	"./crystal_sleep_death.png": 3978,
	"./darkness_death.png": 9125,
	"./druika.mp4": 6138,
	"./exit_room_ladder.png": 9334,
	"./frozendeath.png": 2339,
	"./fungideath.png": 5128,
	"./goblin_shrine.png": 7590,
	"./gold_medallion.png": 8179,
	"./hiddenRoom.png": 758,
	"./inventory_panel_background.png": 9405,
	"./jade_figureine.png": 4234,
	"./ladder_Exit_pit.png": 4802,
	"./ladder_no_player_exit.png": 5918,
	"./lantern_darkness.png": 4661,
	"./nightcrawlers.png": 7786,
	"./parchment-texture.png": 6605,
	"./parchmentmap.mp4": 4360,
	"./player_HoldingOrb_Extended_ladder_exit.png": 467,
	"./player_HoldingOrb_rusty_lader_hole.png": 6927,
	"./player_exiting_cave_end.mp4": 5972,
	"./player_holding_orb_facingExtended ladder.png": 8552,
	"./player_holding_orb_rusty_ladder_hole.mp4": 4693,
	"./ruby.png": 2891,
	"./rusty_ladder_exit.png": 5442,
	"./rusty_ladder_player.png": 405,
	"./sandwraith.png": 5436,
	"./sulfur_death.png": 4527,
	"./torch_darkness.png": 1411,
	"./tranquil_pool_caveroom.png": 1939,
	"./trinkets_trapdoor.png": 9537,
	"./vortex_death.png": 3816,
	"./water_nixie_tranquil_pool.png": 2042,
	"./wizardroom.png": 9520,
	"./wizardroomAfter.png": 9957,
	"./wizardroomRock.png": 3296,
	"./wizardroomback.png": 3298,
	"./wizardroomempty.png": 6624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;